import { FC, useState } from "react";
import Section from "components/kaleido/parts/Section";
import AnchorTarget from "components/official/AnchorTarget";
import Headline from "components/kaleido/long/parts/Headline";
import Content from "components/kaleido/parts/Content";
import styled from "styled-components";
import useObserver from "lib/hooks/kaleido/useObserver";

const Distribution: FC = () => {
  const [visibleSection, setVisibleSection] = useState<string | null>(null);
  const sectionVisibilityFlags = useObserver(setVisibleSection);
  const isVisible = visibleSection === "distribution" || sectionVisibilityFlags["distribution"];

  return (
    <StyledSection className={`section ${isVisible ? "visible" : "hidden"}`} id="distribution">
      <AnchorTarget id="distribution" />
      <Headline src={"/image/lp/kaleido/distribution/head.png"} alt="配信情報" />
      <Content>
        <BannerArea>
          <SectionTitle>【見放題】配信サイト</SectionTitle>
          <LinkGrid>
            <Link href="https://www.youtube.com/@kaleidostar_official" target="_blank">YouTube</Link>
            <Link href="https://atdx.at-x.com/" target="_blank">AT-DX</Link>
            <Link href="https://tv.dmm.com/vod/" target="_blank">DMM TV</Link>
            <Link href="https://animestore.docomo.ne.jp/" target="_blank">dアニメストア</Link>
            <Link href="https://ch.nicovideo.jp/danime" target="_blank">dアニメストア ニコニコ支店</Link>
            <Link href="https://www.amazon.co.jp/Amazon-Video/b/?ie=UTF8&node=2351649051&ref_=nav_cs_prime_video" target="_blank">dアニメストア for Prime Video</Link>
            <Link href="https://fod.fujitv.co.jp/" target="_blank">FOD</Link>
            <Link href="https://lemino.docomo.ne.jp/" target="_blank">Lemino</Link>
            <Link href="https://www.hulu.jp/" target="_blank">Hulu</Link>
            <Link href="https://channel.rakuten.co.jp/" target="_blank">Rチャンネル</Link>
            <Link href="https://video.unext.jp/" target="_blank">U-NEXT</Link>
            <Link href="https://www.amazon.co.jp/gp/video/storefront?ie=UTF8&benefitId=animetimesjp&ref_=&ref=dvm_pds_goo_jp_ac_c_a_mkw_sYK3xwjLJ-dc_pcrid_541043801417&mrntrk=slid__pgrid_124656399965_pgeo_1009783_x__adext__ptid_kwd-1410605591264&gclid=Cj0KCQjw5ea1BhC6ARIsAEOG5px_Ek9VJ1A8KNGP_ORSUKzPTadvSNOzT7INHIv5amCc1bhe0k3Okl8aAh54EALw_wcB" target="_blank">アニメタイムズ</Link>
            <Link href="https://www.animehodai.jp/" target="_blank">アニメ放題</Link>
            <Link href="https://www.b-ch.com/" target="_blank">バンダイチャンネル</Link>
            <Link href="https://douga.flat-flat.jp/" target="_blank">ふらっと動画</Link>
          </LinkGrid>
          <SectionTitle>【都度課金】配信サイト</SectionTitle>
          <LinkGrid>
            <Link href="https://www.amazon.co.jp/Amazon-Video/b/?ie=UTF8&node=2351649051&ref_=nav_cs_prime_video" target="_blank">Amazon Prime Video</Link>
            <Link href="https://tv.rakuten.co.jp/" target="_blank">Rakuten TV</Link>
            <Link href="https://www.videx.jp/" target="_blank">VIDEX</Link>
            <Link href="https://a.happydouga.jp/web/index.php" target="_blank">HAPPY!動画</Link>
            <Link href="https://www.b-ch.com/" target="_blank">バンダイチャンネル</Link>
            <Link href="https://www.videomarket.jp/" target="_blank">ビデオマーケット</Link>
            <Link href="https://ch.nicovideo.jp/" target="_blank">ニコニコチャンネル</Link>
          </LinkGrid>
        </BannerArea>
      </Content>
    </StyledSection>
  );
};
export default Distribution;

const StyledSection = styled(Section)`
  transition: opacity 0.5s ease-in-out;
  opacity: 0;
  &.visible {
    opacity: 1;
  }
  &.hidden {
    opacity: 0;
  }

  @media screen and (max-width: 350px) {
    margin-top: 80px;
    margin-bottom: 50px;
  }
  @media screen and (min-width: 351px) {
    margin-top: 120px;
    margin-bottom: 60px;
  }
  @media screen and (min-width: 501px) {
    margin-top: 120px;
    margin-bottom: 80px;
  }
  @media screen and (min-width: 961px) {
    margin-top: 150px;
    max-width: 900px;
    margin-bottom: 100px;
  }
  @media screen and (min-width: 1111px) {
    max-width: 1000px;
  }
  @media screen and (min-width: 1281px) {
    margin-bottom: 120px;
  }
`;
const SectionTitle = styled.h2`
  text-align: center;
  background-color: #F48FB1;
  color: #FFFFFF;
  padding: 24px 0;
  margin: 0;
  font-weight: bold;

  @media screen and (max-width: 500px) {
    font-size: 20px;
    padding: 18px 0;
  }
  @media screen and (min-width: 501px) {
    font-size: 22px;
    padding: 20px 0;
  }
  @media screen and (min-width: 961px){
    font-size: 28px;
    padding: 20px 0;
  }
`;
const LinkGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 32px;
  padding: 32px 0;
  background-color: #F8F8F8;

  @media screen and (max-width: 960px) {
    gap: 2vw;
  }
`;
const Link = styled.a<{ disabled?: boolean }>`
  color: #E91E63;
  text-decoration: none;
  text-align: center;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};

  &:hover {
    text-decoration: ${({ disabled }) => (disabled ? 'none' : 'underline')};
  }

  @media screen and (max-width: 400px) {
    font-size: 12px;
    padding: 4px 2px;
  }
  @media screen and (min-width: 401px) {
    font-size: 13px;
    padding: 6px 2px;
  }
  @media screen and (min-width: 451px) {
    font-size: 14px;
    padding: 6px 2px;
  }
  @media screen and (min-width: 501px) {
    font-size: 15px;
    padding: 3px 2px;
  }
  @media screen and (min-width: 601px) {
    font-size: 17px;
    padding: 2px 1px;
  }
  @media screen and (min-width: 961px){
    font-size: 24px;
  }
`;
const BannerArea = styled.div`
  box-sizing: border-box;
`;
